import { apiClient } from "./data/api";
import { useEffect, useRef, useState } from "react";
import { MessageProps } from "./interface";
import {ReactComponent as SendChatArrow} from "./icons/send-chat-btn.svg";
import {ReactComponent as DownTriangle} from "./icons/triangle-down.svg";
import {ReactComponent as UpTriangle} from "./icons/triangle-up.svg";
import moment from "moment";
import Bargraph from "./bargraph";
import Linegraph from "./linegraph";
import Piegraph from "./piechart";
// import toastMessage from "./toast-message";
// import "react-toastify/dist/ReactToastify.css";
import Loader from "./loader";
// import { signIn, useSession } from "next-auth/react";
import { StatusCodes } from "http-status-codes";
import Table from "./table";
import ACCESS_TOKEN from "./data/token";
import getConversationStub from "./data/stubs/get_conversation.json"
import postConversationStub from "./data/stubs/post_conversation.json"
import { getMsalAccessToken } from "index";

const plotChart = ({
  assistantMessageObj,
}: {
  assistantMessageObj: MessageProps;
}) => {
  switch (assistantMessageObj.visualization_type?.toLowerCase()) {
    case "table":
      return <Table assistantMessageObj={assistantMessageObj} />;
    case "bar":
      if (assistantMessageObj?.data?.length !== 0)
        return <Bargraph barGraphProps={assistantMessageObj.data[0]} />;
      break
    case "line":
      if (assistantMessageObj?.data?.length !== 0)
        return <Linegraph lineGraphProps={assistantMessageObj.data[0]} />;
      break
    case "pie":
      if (assistantMessageObj?.data?.length !== 0)
        return 
            <Piegraph pieGraphProps={assistantMessageObj.data} />;
  }
};

const UserMessage = ({ userMessageObj }: { userMessageObj: MessageProps }) => {
  let formattedDateString;
  if (userMessageObj.timestamp) {
    const originalDateString = userMessageObj.timestamp;
    // Parse and format the date string
    formattedDateString = moment(originalDateString).format("DD/MM/YYYY HH:mm");
  }
  return (
    <div className="chat chat-end mt-5">
      <div
        className="chat-bubble text-black drop-shadow-xl"
        style={{ background: "#e6dcff" }}
      >
        {userMessageObj.conversation_text}
        <p className="text-right mt-2 text-sm font-thin">
          {formattedDateString}
        </p>
      </div>
    </div>
  );
};

const AssistantMessage = ({
  assistantMessageObj,
}: {
  assistantMessageObj: MessageProps;
}) => {
  const [isSourceToggled, setIsSourceToggled] = useState<boolean>(false);
  let formattedDateString;
  if (assistantMessageObj.timestamp) {
    const originalDateString = assistantMessageObj.timestamp;
    // Parse and format the date string
    formattedDateString = moment(originalDateString).format("DD/MM/YYYY HH:mm");
  }
  return (
    <div className="mt-5 ">
      <div className="chat chat-start">
        <div className="chat-bubble bg-white text-black drop-shadow-xl">
          <p>{assistantMessageObj?.conversation_text}</p>
          {assistantMessageObj?.data && plotChart({assistantMessageObj})}
          {assistantMessageObj.query && (
            <div>
              <hr className="mt-5 border-slate-400"></hr>
              <button
                className="flex items-center gap-2"
                onClick={() => setIsSourceToggled(!isSourceToggled)}
              >
                <p className="font-medium text-[#7500C0]">Source</p>
                <div className="w-5 h-5">
                  {isSourceToggled ? (
                    <div className="rotate-180">
                      <UpTriangle />
                    </div>
                  ) : (
                    <div>
                      <DownTriangle />
                    </div>
                  )}
                </div>
              </button>
              {isSourceToggled && (
                <p className="">{assistantMessageObj.query}</p>
              )}
            </div>
          )}
          <p className="text-right mt-2 text-sm font-thin">
            {formattedDateString}
          </p>
          {assistantMessageObj?.data && (
            <p className="text-sm"><b>Disclaimer : </b>Result shown in response is limited to max. 10 records.</p>
          )}
        </div>
      </div>
    </div>
  );
};

const Message = ({ messageObj }: { messageObj: MessageProps }) => {
  switch (messageObj.role) {
    case "user":
      return <UserMessage userMessageObj={messageObj} />;
    case "assistant":
      return <AssistantMessage assistantMessageObj={messageObj} />;
    default:
      return null;
  }
};

export default function InputChatBox({
  historyID,
  handleHistoryID,
  chatWindowMinimized
}: {
  historyID: number | string;
  handleHistoryID: (id: number | string) => void;
  chatWindowMinimized:boolean
}) {
  const [userInput, setUserInput] = useState<string>("");
  const [messages, setMessages] = useState<MessageProps[]>([]);
  const textareaRef = useRef<any>(null);
  const [isFocused, setIsFocused] = useState(false);
  const [inputDisabled, setInputDisabled] = useState(true);
  const [loading, setLoading] = useState<boolean>(false);
  // automatically scroll to bottom of chat
  const messagesEndRef = useRef<HTMLDivElement | null>(null);
  // const { data: session } = useSession();

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };
  useEffect(() => {
    scrollToBottom();
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollTop = messagesEndRef.current.scrollHeight;
    }
  }, [messages]);

  useEffect(() => {
    const adjustHeight = () => {
      if (textareaRef.current) {
        textareaRef.current.style.height = "auto"; // Reset the height
        textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`; // Set the height to match the scroll height
      }
    };
    adjustHeight();
  }, [userInput]);

  useEffect(() => {
    const getOldConversion = async () => {
      if (historyID !== -1) {
        setLoading(true);
        apiClient
          .get(`/conversation/?conversation_id=${historyID}`, {
            headers: {
              // @ts-ignore
              Authorization: `Bearer ${await getMsalAccessToken()}`,
            },
          })
          .then(
            response => {
              // let stub = getConversationStub;
              // setMessages(stub);
              console.log(response.data);
              setMessages(response.data);
              setLoading(false);
            },
            error => {
              setLoading(false);
              if (error.response?.data?.detail) {
                console.log(error.response?.data?.detail);
              }
              // if (error.response?.status == StatusCodes.UNAUTHORIZED) {
              //   void signIn("azure-ad", undefined, { prompt: "login" });
              // }
              if (error.response?.status != StatusCodes.UNAUTHORIZED) {
                // toastMessage(`Error Occured while fetching the conversation for the id ${historyID}`);
              }
            }
          );
      } else {
        setMessages([]);
      }
    }
 
    getOldConversion();
  }, [historyID]);

  let sendMessage = async (question: string) => {
    setLoading(true);
    let payload;
    if (historyID == -1) {
      payload = {
        prompt: question,
      };
    } else {
      payload = {
        prompt: question,
        conversation_id: historyID,
      };
    }
    apiClient
      .post('/conversation/', payload, {
        headers: {
          // @ts-ignore:
          Authorization: `Bearer ${await getMsalAccessToken()}`,
        },
      })
      .then(
        response => {
          // let stub = postConversationStub;
          // handleHistoryID(stub.conversation_id);
          // appendMessage(stub);
          handleHistoryID(response.data.conversation_id);
          appendMessage(response.data);
          // console.log(stub);
          setLoading(false);
        },
        error => {
          setLoading(false);
          if (error.response?.data?.detail) {
            console.log(error.response?.data?.detail);
          }
          if (error.response?.status == StatusCodes.UNAUTHORIZED) {
            let stub = postConversationStub;
            handleHistoryID(stub.conversation_id);
            appendMessage(stub);
            // void signIn("azure-ad", undefined, { prompt: "login" });
            // messages.pop();
            // setMessages(messages);
            // toastMessage('Failed to fetch response for your question. Try again.');
          } else if (error.response?.status == StatusCodes.INTERNAL_SERVER_ERROR) {
            let stub = postConversationStub;
            handleHistoryID(stub.conversation_id);
            appendMessage(stub);
            // toastMessage(
            //   "Failed to fetch response for your question. Try again."
            // );
            // messages.pop();  // to remove the user entered question from the array as it persists and is visible on the UI without its corresponding answer.
            // setMessages(messages);
          } else {
            // toastMessage(
            //   "Failed to fetch response for your question. Try again."
            // );
          }
        }
      );
  };

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    if (!userInput.trim()) return;
    sendMessage(userInput);
    setMessages((prevMessages) => [
      ...prevMessages,
      { role: "user", conversation_text: userInput },
    ]);
    setUserInput("");
    setInputDisabled(true);
    scrollToBottom();
    console.log(messages);
    //handleRunCompleted();
  };

  const appendMessage = (messageObj: MessageProps) => {
    setMessages((prevMessages) => [...prevMessages, messageObj]);
  };

  // handleRunCompleted - re-enable the input form
  const handleRunCompleted = () => {
    setInputDisabled(false);
  };

  const handleKeyDown = (event: any) => {
    if (event.key === "Enter" && !event.shiftKey) {
      event.preventDefault();
      handleSubmit(event);
    }
  };

  return (
    <div
      className={`px-6 w-full ${chatWindowMinimized ? 'w-full' : 'lg:w-3/4'} flex flex-col justify-between ${chatWindowMinimized ? 'mt-4' : ''}`}
      style={{ background: '#f5f5f5' }} //#f5f5f5
    >
      {!messages.length && (
        <div className="mt-4">
          <p className="text-black  font-medium text-sm" style={{ color: '#7f26d3' }}>
            Welcome , I am your conversation AI Assistant. How can I help you today? You can ask me
            anything related to the Demand Planning and Your Data. At any time if you wish to end
            the conversation, please type &apos;exit&apos;.
          </p>
        </div>
      )}
      {messages.length !== 0 && (
        <div
          ref={messagesEndRef}
          className={` ${
            window.screen.height > 600 ? chatWindowMinimized ? 'h-[52svh]' : 'h-[60svh]' : 'h-[66svh]'
          }  overflow-y-auto overflow-x-hidden mt-2`}
          style={{ background: '#f5f5f5' }} //#f5f5f5
        >
          {messages.map((msg, index) => (
            <Message key={index} messageObj={msg} />
          ))}
        </div>
      )}
      {loading && <Loader />} {/* Show loader when loading */}
      <div className="mb-4">
        <form onSubmit={handleSubmit}>
          <div
            className={`bg-white flex items-center px-2 mt-2.5 rounded-lg ${
              isFocused && 'ring-1 ring-[#7500C0] drop-shadow-xl'
            }`}
          >
            {/* <textarea
                name="message"
                id="message"
                rows={1}
                className="block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                defaultValue={""}
              /> */}

            <textarea
              className="bg-white text-black resize-none overflow-hidden border-none px-2 py-1 w-full focus:outline-none"
              value={userInput}
              placeholder="Chat with Conversational AI"
              onChange={e => {
                setUserInput(e.target.value);
                e.target.value != '' ? setInputDisabled(false) : setInputDisabled(true);
              }}
              onKeyDown={handleKeyDown}
              rows={1}
              style={{ minHeight: '45px' }} // initial minimum height
              onFocus={() => setIsFocused(true)}
              onBlur={() => setIsFocused(false)}
              disabled={loading}
            />
            <button
              type="submit"
              className="text-purple-700 w-10 h-10 disabled:text-slate-400 active:text-purple-800"
              disabled={inputDisabled || loading}
            >
              <SendChatArrow />
            </button>
          </div>
        </form>

        <div className="flex gap-x-4 sm:col-span-2 ">
          <div className="text-sm leading-6 text-gray-600">
            Response generated by AI. Verify accuracy and privacy restrictions
            before use.{" "}
            <a href="#" className="font-semibold text-indigo-600">
              <u>Terms&nbsp;of&nbsp;use</u>
            </a>
            <a href="#" className="font-semibold text-indigo-600 ml-1">
              <u>Privacy&nbsp;Policy</u>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
